import { NavLink, useNavigate } from "react-router-dom";
import UserData from "../Controls/UserData";
import Helpers from "../Controls/helpers";

export default function Menu({ updateLogin }) {
  const navigate = useNavigate();
  const isLoggedIn = !!window.sessionStorage.getItem("BearerToken");
  const userData = isLoggedIn ? UserData.UserData() || {} : {};
  const showHiring = Helpers.canHire(userData);
  const showAdmin = Helpers.isSysAdmin(userData);

  function onLogout(e) {
    e.preventDefault();
    window.sessionStorage.clear();
    UserData.Clear();
    updateLogin(false);
    navigate("/");
  }

  return (
    <>
      {isLoggedIn ? (
        <nav>
          <ul className="topMenu">
            <li>
              <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="/account" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Account
              </NavLink>
            </li>
            <li>
              <NavLink to="/careers" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Careers
              </NavLink>
            </li>
            <li>
              <NavLink to="/skills" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Skills
              </NavLink>
            </li>
            <li>
              <NavLink to="/skillTests" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Skill Tests
              </NavLink>
            </li>
            <li>
              <NavLink to="/skillCalendar" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Skill Calendar
              </NavLink>
            </li>
            <li>
              <NavLink to="/employments" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Employment
              </NavLink>
            </li>
            <li>
              <NavLink to="/connections" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Connections
              </NavLink>
            </li>
            {showHiring ? (
              <li>
                <NavLink to="/recruit" className={({ isActive }) => (isActive ? "active" : undefined)}>
                  Hiring
                </NavLink>
              </li>
            ) : null}
            {showAdmin ? (
              <li>
                <NavLink to="/admin" className={({ isActive }) => (isActive ? "active" : undefined)}>
                  Admin
                </NavLink>
              </li>
            ) : null}
            <li>
              <NavLink to="/" onClick={onLogout} className={({ isActive }) => (isActive ? "active" : undefined)}>
                Logout
              </NavLink>
            </li>
          </ul>
        </nav>
      ) : (
        <nav>
          <ul className="topMenu">
            <li>
              <NavLink to="/" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Login
              </NavLink>
            </li>
            <li>
              <NavLink to="/register" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Register
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : undefined)}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to="/faq" className={({ isActive }) => (isActive ? "active" : undefined)}>
                FAQ
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : undefined)}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
}
